// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"575bd9a6","267":"7ea2a72e","380":"76efa09b","453":"d212c517","637":"8b9c9f93","663":"523f214a","941":"13138941"}[chunkId] + ".chunk.js";
};